
import { Helmet } from "react-helmet";
import { safeJsonStringify } from "@/lib/utils";

interface BreadcrumbItemProps {
  name: string;
  url: string;
  position: number;
}

interface BreadcrumbSchemaProps {
  items: BreadcrumbItemProps[];
}

export const BreadcrumbSchema = ({ items }: BreadcrumbSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map(item => ({
      "@type": "ListItem",
      "position": item.position,
      "name": item.name,
      "item": item.url.startsWith('http') ? item.url : `https://edgefi.com${item.url}`
    }))
  };
  
  return (
    <Helmet>
      <script type="application/ld+json">
        {safeJsonStringify(schema)}
      </script>
    </Helmet>
  );
};
